module.exports = __webpack_public_path__ + "static/media/4_3.c2670423.png";